import { render, staticRenderFns } from "./Toberecruited.vue?vue&type=template&id=13fc984f&scoped=true"
import script from "./Toberecruited.vue?vue&type=script&lang=js"
export * from "./Toberecruited.vue?vue&type=script&lang=js"
import style0 from "./Toberecruited.vue?vue&type=style&index=0&id=13fc984f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13fc984f",
  null
  
)

export default component.exports